export default __webpack_public_path__ + "static/media/server.ea147529.svg";